import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=5349023f&scoped=true&"
import script from "./lucky.vue?vue&type=script&lang=js&"
export * from "./lucky.vue?vue&type=script&lang=js&"
import style0 from "./lucky.vue?vue&type=style&index=0&id=5349023f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349023f",
  null
  
)

export default component.exports